import { render, staticRenderFns } from "./BSignUpPhoneStep.vue?vue&type=template&id=a6c47ba0&"
import script from "./BSignUpPhoneStep.vue?vue&type=script&lang=ts&"
export * from "./BSignUpPhoneStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports